
<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" viewBox="0 0 56 56">
  <title>Small illustration of a hand with a magenta heart in the center</title>
  <path
    fill-rule="evenodd"
    stroke="#FF0064"
    stroke-linejoin="round"
    stroke-width="2"
    d="M33.153 37.346c-1.15 1.162-2.36 2.261-3.502 3.432-.031.032-.066.066-.112.072-.051.006-.1-.025-.143-.054-2.27-1.579-7.646-7.616-3.604-9.75.883-.465 2.073-.051 2.742.694.67.745.934 1.732 1.13 2.686.404-.753.945-1.437 1.593-2.014.704-.627 1.832-.67 2.708-.274 2.158.975-.383 4.756-.383 4.756-.141.156-.285.307-.43.452z"
    clip-rule="evenodd"
  />
  <path
    fill-rule="evenodd"
    stroke="#05070F"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="M19.167 7.968c1.8-.37 2.833 1.213 3.355 3.722.52 2.509.992 4.894 1.394 7.068.403 2.174.648 5.124 2.148 5.124s1.617-4.933 1.559-6.457c-.058-1.524.311-6.42.311-8.355 0-1.935.927-4.07 2.924-4.07 1.998 0 2.347 2.884 2.173 5.737-.175 2.854-.11 7.675-.39 9.49-.28 1.816-.894 4.34 0 4.695.893.355 1.599-2.184 2.489-4.174.89-1.99 3.045-6.678 3.589-8.345.544-1.666 1.684-4.166 4.076-3.333 2.392.833 0 7.075-1.304 10.233-1.303 3.157-4.219 8.432-3.155 9.13 1.065.696 2.899-2.142 4.039-3.511 1.14-1.37 2.06-2.848 2.86-3.771.801-.923 2.474-2.883 3.986-1.442 1.512 1.442.537 3.169-.51 4.72-1.048 1.55-4.482 5.4-5.916 8.17-1.434 2.77-2.182 5.997-3.114 8.818-.933 2.82-2.233 6.5-5.097 7.287-2.865.787-5.486-.757-5.486-.757S25.37 49.99 22 48.384c-3.369-1.607-6.154-6.647-7.75-8.475-1.596-1.827-4.506-4.955-5.925-6.528-1.42-1.573-3.35-2.784-1.675-4.949s8.156 3.427 9.185 4.54c1.03 1.114 2.695 1.942 3.332 1.321.637-.62.56-3.654 0-8.398s-.574-5.774-.953-8.157c-.38-2.382-1.137-5.12-1.137-6.608 0-1.487.29-2.792 2.09-3.162z"
    clip-rule="evenodd"
  />
</svg>
